/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { LookupControl } from "./LookupControl";
import { LookupProvider } from "./LookupProvider";
import { LookupView } from "./LookupView";
var LookupControlFactory = /** @class */ (function () {
    function LookupControlFactory() {
    }
    LookupControlFactory.CreateLookupControl = function (form, element, logger) {
        var fieldId = element.id;
        var view = new LookupView(element);
        var provider = new LookupProvider();
        var lookupControl = new LookupControl(view, form, fieldId, provider, logger);
        element.d365mkt_lookupControl = lookupControl;
        return lookupControl;
    };
    LookupControlFactory.getLookupFieldControlsFromInput = function (input) {
        return input.d365mkt_lookupControl;
    };
    return LookupControlFactory;
}());
export { LookupControlFactory };
